import axios from 'axios';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue';

Vue.use(VueSweetalert2);

const functions = {
  maxDispatch: 24,
  // TIEMPO DE REFRESCO DE LAS TABLAS (SEGUNDOS)
  timeRefresh: 20,
  privilegeUser: [
    {id: 'ADM', name: 'Administrador'},
    {id: 'CON', name: 'Conductor'}
  ],
  specificProduct: [
    {id: '--', name: 'No es un producto específico.'},
    {id: 'wi', name: 'Vino'}
  ],
  typeProduct: [
    {id: 'U', name: 'Unidad'},
    {id: 'P', name: 'Pack'}
  ],
  statusDispatch: [
    {'id': '0', 'name': 'Anulado'},
    {'id': '1', 'name': 'Entregado'},
    {'id': '4', 'name': 'Pendiente'},
    {'id': '20', 'name': 'Dirección incompleta'},
    {'id': '30', 'name': 'No hay número'},
    {'id': '40', 'name': 'Cambio de domicilio'},
    {'id': '50', 'name': 'Desconocido en la dirección'},
    {'id': '60', 'name': 'No hay quien reciba'},
    {'id': '70', 'name': 'Rehusada'},
    {'id': '220', 'name': 'En distribución'},
    {'id': '230', 'name': '2da ida, sin moradores'},
    {'id': '250', 'name': '1ra ida, sin moradores'},
    {'id': '280', 'name': 'Ruta asignada'},
    {'id': '290', 'name': 'Regreso al inventario'},
    {'id': '300', 'name': 'En sincronización'},
    {'id': '310', 'name': 'Despacho syncronizado'},
  ],
  statusDispatchMobile: [
    {'id': '1', 'name': 'Entregado'},
    {'id': '20', 'name': 'Dirección incompleta'},
    {'id': '30', 'name': 'No hay número'},
    {'id': '40', 'name': 'Cambio de domicilio'},
    {'id': '50', 'name': 'Desconocido en la dirección'},
    {'id': '60', 'name': 'No hay quien reciba'},
    {'id': '70', 'name': 'Rehusada'},
    {'id': '230', 'name': '2da ida, sin moradores'},
    {'id': '250', 'name': '1ra ida, sin moradores'},
  ],
  typeDispatch: [
    {'id': 'ON', 'name': 'Compra online'},
    {'id': 'BO', 'name': 'Boleta'},
    {'id': 'FA', 'name': 'Factura'},
    {'id': 'SD', 'name': 'Sin documento'},
  ],
  typeDispatchTracking: [
    {'id': 'ON', 'name': 'Compra online'},
    {'id': 'BO', 'name': 'Boleta'},
    {'id': 'FA', 'name': 'Factura'},
  ],
  // DIRECCIÓN INCOMPLETA - NO HAY NÚMERO - CAMBIO DE DOMICILIO - CAMBIO DOMICILIO - REHUSADA - 2 IDA
  syncStatusDispatch: ['20', '30', '40', '70', '230'],
  // PENDIENTE, DESCONOCIDO, NO HAY QUIEN RECIBA, 1 IDA
  drawStatusRoute: ['4', '50', '60', '250'],
  statusVehicle: [
    {'id': 'AU', 'name': 'Auto'},
    {'id': 'MO', 'name': 'Motocicleta'}
  ],
  statusRoute: [
    {'id': 'ESP', 'name': 'En espera'},
    {'id': 'ECU', 'name': 'En distribución'},
    {'id': 'FIN', 'name': 'Finalizado'},
    {'id': 'DET', 'name': 'Detenido'},
    {'id': 'CAN', 'name': 'Cancelado'},
  ],
  isDict(v) {
    return typeof v==='object' && v!==null && !(v instanceof Array) && !(v instanceof Date);
  },
  async loadDataStructure(form, data, defaultField={}){
    for (let key in data) {
      // PREGUNTO SI LA LLAVE ESTÁ
      if (data.hasOwnProperty(key)) {
        // PREGUNTO SI !NO! LLEGUÉ A LA ESTRCUTURA DEL OBJETO DEL INPUT
        // DE SER ASÍ DEBO SEGUIR BAJANDO, APLICANDO RECURSIVIDAD
        // PREGUNTO SU ES UNA LISTA, LA GENERO VACÍA
        if(Array.isArray(data[key])){
          form[key] = [];
          this.loadDataStructure(form[key], data[key], defaultField);
        }
        else if (this.isDict(data[key])){
          // DE LO CONTRARIO, ES UN DICCIONARIO
          form[key] = {};
          this.loadDataStructure(form[key], data[key], defaultField);
        }else{
          if(defaultField.hasOwnProperty(key)){
            form[key] = this.defaultFields(Object.assign({}, {value: data[key]}, defaultField[key]));
          }else{
            form[key] = this.defaultFields({value: data[key]});
          }
        }
      }
    }
  },
  generateJsonStructure(form, data){
    // RECORRO LAS LLAVES DE LOS FOMULARIOS
    let is_valid = true;
    for (let key in form) {
      // PREGUNTO SI LA LLAVE ESTÁ
      if (form.hasOwnProperty(key)) {
        // PREGUNTO SI !NO! LLEGUÉ A LA ESTRCUTURA DEL OBJETO DEL INPUT
        // DE SER ASÍ DEBO SEGUIR BAJANDO, APLICANDO RECURSIVIDAD
        if(!form[key]['_structure']){
          // PREGUNTO SU ES UNA LISTA, LA GENERO VACÍA
          if(Array.isArray(form[key])){
            data[key] = [];
          }else{
            // DE LO CONTRARIO, ES UN DICCIONARIO
            data[key] = {};
          }
          is_valid = is_valid && this.generateJsonStructure(form[key], data[key]);
        }else{
          if(form[key]._type === 'select'){
            // PARA EL SELECT
            data[key] = form[key].value[form[key]._key];
          }
          else{
            // PARA EL INPUT
            data[key] = form[key].value;
            if(form[key].value === '' && form[key].required) delete data[key];
          }
          // SI EL CAMPO ES REQUERIDO LO VALIDO
          if(form[key].required){
            // SI EL CAMPO NO ES VACÍO LA VALIDACIÓN ES CORRECTA
            if(form[key].value !== ''){
              form[key].is_valid = true;
            }else{
              form[key].is_valid = false;
              form[key].message_error = 'Este campo no puede estar en blanco.';
              // DE LO CONTRARIO ES INCORRECTA
              is_valid = false;
              // ELIMINO LA LLAVE
            }
          }
        }
      }
    }
    return is_valid;
  },
  generateBackendError(form, data_error){
    for (let key in form) {
      // PREGUNTO SI LA LLAVE ESTÁ
      if (form.hasOwnProperty(key)) {
        // PREGUNTO SI !NO! LLEGUÉ A LA ESTRCUTURA DEL OBJETO DEL INPUT
        // DE SER ASÍ DEBO SEGUIR BAJANDO, APLICANDO RECURSIVIDAD
        if(!form[key]['_structure']){
          // Y HAY ELEMENTOS EN EL DATA
          if(data_error[key] !== undefined){
            this.generateBackendError(form[key], data_error[key]);
          }
        }else{
          form[key].message_error = '';
          if(data_error.hasOwnProperty(key)){
            for (let _key in data_error[key]){
              if(data_error[key].hasOwnProperty(_key)){
                form[key].message_error += data_error[key][_key];
              }
            }
          }
          form[key].is_valid = false;
        }
      }
    }
  },
  defaultFields(data={}){
    return {
      // VALOR
      value: data.hasOwnProperty('value') ? data['value'] : '',
      // LO PUEDO EDITAR?
      edit: data.hasOwnProperty('edit') ? data['edit'] : true,
      // OPCIONAL PARA CUANDO SE EDITE (POR SI EL CAMPO SE DEJA NULO COMO LA CONTRASEÑA)
      required: data.hasOwnProperty('required') ? data['required'] : true,
      readonly: data.hasOwnProperty('readonly') ? data['readonly'] : false,
      // // LO VALIDO?
      // validate: data.hasOwnProperty('validate') ? data['validate'] : true,
      // EL CAMPO ES VÁLIDO? (UNA VEZ REALIZADA LA VALIDACIÓN)
      is_valid: data.hasOwnProperty('is_valid') ? data['is_valid'] : null,
      // SI NO ES VÁLIDO, CÚAL ES EL ERROR?
      message_error: data.hasOwnProperty('message_error') ? data['message_error'] : 'Este campo no puede estar en blanco.',
      // LARGO MÁXIMO
      maxlength: data.hasOwnProperty('maxlength') ? data['maxlength'] : 30,
      // SI ES SELECT, SE GUARDAN LAS OPCIONES
      options: data.hasOwnProperty('options') ? data['options'] : [],
      // PARA SABER CUÁL ES EL VALOR DE LA KEY EN DONDE SE GUARDA EL VALUE EN UN OPTION
      // {value: id, text: texto} => LA KEY SERÍA "value"
      _key: data.hasOwnProperty('_key') ? data['_key'] : 'id',
      // PARA SABER SI ME ENCUENTRO EN LA ESTRUCTURA DEL CAMPO
      // CON ESTO VALIDO SI DEBO SEGUIR APLICANDO RECURSIVIDAD
      _structure: true,
      // TIPO DE CAMPO, INPUT, SELECT,
      _type: data.hasOwnProperty('_type') ? data['_type'] : 'input',
    };
  },
  async updateObject(url, data){
    let status = false;
    await axios.patch(url, data).then(() => {
      status = true;
    }).catch(async (error) => {
      // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
      await Vue.swal({
        title: 'Error',
        type: 'error',
        html: 'Ha ocurrido un error inesperado, inténtalo nuevamente. Si el problema consiste, póngase en contacto con el administrador del sistema.',
      });
    });
    return status;
  },
  lang_es: {
    viewFullscreen: "Ver en pantalla completa",
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    weekdays: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado"
    ],
    downloadJPEG: "Descargar Imagen JPEG",
    downloadPDF: "Descargar Documento PDF",
    downloadPNG: "Descargar Imagen PNG",
    downloadSVG : "Descargar Imagen SVG",
    printChart: "Imprimir gráfico",
    resetZoom: "Reiniciar zoom",
    resetZoomTitle: "Reiniciar zoom",
    getWeekDays: function(){
      return this.weekdays;
    },
    getMonths: function(){
      return this.months;
    },
    getShortWeekDays: function(){
      return this.weekdays.map(function(day){
        return day.substring(0,3);
      });
    },
    getShortMonths: function(){
      return this.months.map(function(month){
        return month.substring(0,3);
      });
    },
    getLang(){
      return {
        viewFullscreen: this.viewFullscreen,
        months: this.getMonths(),
        weekdays: this.getWeekDays(),
        shortWeekdays: this.getShortWeekDays(),
        shortMonths: this.getShortMonths(),
        downloadJPEG: this.downloadJPEG,
        downloadPDF: this.downloadPDF,
        downloadPNG: this.downloadPNG,
        downloadSVG : this.downloadSVG,
        printChart: this.printChart,
        resetZoom: this.resetZoom,
        resetZoomTitle: this.resetZoomTitle,
      }
    }
  },
}

export default functions;